import React, { Component } from 'react';
import '../Home/Home.css';
import Navbar from '../Components/Navbar/Navbar'
import Footer from '../Components/Footer/Footer'
import axios from 'axios'
import { LinkAPI } from '../../API/API'
class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
        name: "",
        phone: "",
        email:"",
        message: "",

    }
   
}



  handleChange = event => {
    const isCheckbox = event.target.type === "checkbox";
    this.setState({
        [event.target.name]: isCheckbox
            ? event.target.checked
            : event.target.value
    });

};
validate = () => {
  let nameError = "";
  let phoneError = "";
  let emailError = "";
  let messageError = "";
  if (this.state.name.length < 2 || !isNaN(this.state.name)) {
      nameError = "write your name correct";
  }
  
  if ( isNaN(this.state.phone)|| this.state.phone.length < 10 ||this.state.phone.length > 11 ) {
      phoneError = "invalid phone Numper";
  }
  if (!this.state.email.includes("@")) {
    emailError = "invalid email";
}
  if (this.state.message.length < 2 || !isNaN(this.state.message)) {
    messageError = "write your message correct";
  }


  if (nameError || phoneError || messageError ||emailError) {
      this.setState({ nameError, phoneError, messageError,emailError});
      return false;
  }

  return true;
};
handlesendmessage = event => {
  event.preventDefault();
  const { name, phone,email, message } = this.state
  const Token = localStorage.getItem("userToken")
  const isValid = this.validate();
  if (isValid) {
      // clear form
      axios.post(`${LinkAPI}/api/businessowner/sendcontactmail`, {
        name, phone,email, message
      }, {
          headers: {
              Authorization: `${Token}`
          }
      }
      ).then(res => {
          this.setState({
              name: "",
              phone: "",
              email:"",
              message: "",
              res_done: true,
              networkError: false,
              errordatamessage: false,
              errordatamessagetext: '',
              hasError: false,
              
          })
          setTimeout(() => {
              this.setState({
                  res_done: false
              })
          }, 2000);
      }).catch(error => {
        if (!error.response) {
          this.setState({
              networkError: true
          })
      } else if (error.response.status === 402) {
          window.location.replace("/SignIn");
      } else if (error.response.data.message) {
          this.setState({
              errordatamessage: true,
              errordatamessagetext: error.response.data.message
          })
      } else {
          this.setState({
              hasError: true,
          })
      }      })
  }
};
    render() {

        return (
            <div className="home Policy pt-5">

                <Navbar />


                <div className="Contact1 py-5">
        <div className="container contact my-5">
          <div className="row">
            <div className="col-md-3 textform">
              <div className="contact-info mt-4 text-center">
                <img className="mb-4" src="https://image.ibb.co/kUASdV/contact-image.png" alt="image"/>
                <h2 className="my-4">Contact Us</h2>
                <h4>contact@getkayn.com</h4>
              </div>
            </div>
            <div className="col-md-9 forminput text-left">
              <div className="contact-form ">
                <div className="form-group">
                  <label className="control-label col-sm-2" htmlFor="Name">First Name:</label>
                  <div className="col-sm-10">
                    <input type="text" className="form-control" id="Name" placeholder="Enter your Name" name="name" value={this.state.name} onChange={this.handleChange}></input>
                  </div>
                  <div style={{ fontSize: 12, color: "red" ,textAlign:"center"}}>
                            {this.state.nameError}
                        </div> 
                </div>
                <div className="form-group">
                  <label className="control-label col-sm-2" htmlFor="phone">phone:</label>
                  <div className="col-sm-10">
                    <input type="text" className="form-control" id="phone" placeholder="Enter your phone" name="phone" value={this.state.phone} onChange={this.handleChange}></input>
                  </div>
                  <div style={{ fontSize: 12, color: "red" ,textAlign:"center"}}>
                            {this.state.phoneError}
                        </div> 
                </div>
                <div className="form-group">
                  <label className="control-label col-sm-2" htmlFor="email">Email:</label>
                  <div className="col-sm-10">
                    <input type="email" className="form-control" id="email" placeholder="Enter your email" name="email" value={this.state.email} onChange={this.handleChange}></input>
                  </div>
                  <div style={{ fontSize: 12, color: "red" ,textAlign:"center"}}>
                            {this.state.emailError}
                        </div> 
                </div>
                <div className="form-group">
                  <label className="control-label col-sm-2" htmlFor="message">message:</label>
                  <div className="col-sm-10">
                    <textarea className="form-control" rows="5" id="message" name="message" value={this.state.message} onChange={this.handleChange}></textarea>
                  </div>
                  <div style={{ fontSize: 12, color: "red" ,textAlign:"center"}}>
                            {this.state.messageError}
                        </div> 
                </div>
                <div className="form-group">
                  <div className="col-sm-offset-2 col-sm-10">
                    <button onClick={this.handlesendmessage} className="btn btn-default">Send</button>
                  </div>
                </div>
                {(this.state.res_done? <div style={{ fontSize: 12, color: "#008542" ,textAlign:"center"}}>
                            this message has been send successfully
                        </div> :'')}
              </div>
            </div>
          </div>
        </div>
      </div>
               <Footer/>
            </div>

        )
    }
}
export default ContactUs;